import type { PackageDeal } from '@/libs/interfaces'

import { MOCK_ORG_ID, MOCK_STORE_ID_1, MOCK_STORE_ID_2 } from './seed'

/**
 * Shared package deal fixture data. packageServices/packageProducts reference
 * plausible placeholder serviceID/productID strings, kept internally
 * consistent within this file.
 */
export const mockPackageDeals: PackageDeal[] = [
  {
    packageID: 'package-1',
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_1,
    name: 'Winter Tire Package',
    description: 'Seasonal tire change with storage',
    packageStatus: 'Active',
    from: '2025-10-01',
    to: '2026-03-31',
    createdAt: '2025-01-10T08:00:00Z',
    updatedAt: '2025-01-10T08:00:00Z',
    packageVariants: [
      {
        packageVariantID: 'package-variant-1',
        packageID: 'package-1',
        name: 'Standard',
        price: '1450',
        currency: 'SEK',
        estimatedDurationMinutes: 45,
        packageVariantStatus: 'Active',
        sortOrder: 1,
        createdAt: '2025-01-10T08:00:00Z',
        updatedAt: '2025-01-10T08:00:00Z',
        packageServices: [
          {
            packageServiceID: 'package-service-1',
            packageVariantID: 'package-variant-1',
            serviceID: 'service-tire-change',
            quantity: 1,
            createdAt: '2025-01-10T08:00:00Z',
            updatedAt: '2025-01-10T08:00:00Z',
          },
        ],
        packageProducts: [
          {
            packageProductID: 'package-product-1',
            packageVariantID: 'package-variant-1',
            productID: 'product-tire-set',
            quantity: 1,
            createdAt: '2025-01-10T08:00:00Z',
            updatedAt: '2025-01-10T08:00:00Z',
          },
        ],
      },
      {
        packageVariantID: 'package-variant-2',
        packageID: 'package-1',
        name: 'Premium with Storage',
        price: '1950',
        currency: 'SEK',
        estimatedDurationMinutes: 60,
        packageVariantStatus: 'Active',
        sortOrder: 2,
        createdAt: '2025-01-10T08:00:00Z',
        updatedAt: '2025-01-10T08:00:00Z',
        packageServices: [
          {
            packageServiceID: 'package-service-2',
            packageVariantID: 'package-variant-2',
            serviceID: 'service-tire-change',
            quantity: 1,
            createdAt: '2025-01-10T08:00:00Z',
            updatedAt: '2025-01-10T08:00:00Z',
          },
          {
            packageServiceID: 'package-service-3',
            packageVariantID: 'package-variant-2',
            serviceID: 'service-tire-storage',
            quantity: 1,
            createdAt: '2025-01-10T08:00:00Z',
            updatedAt: '2025-01-10T08:00:00Z',
          },
        ],
        packageProducts: [
          {
            packageProductID: 'package-product-2',
            packageVariantID: 'package-variant-2',
            productID: 'product-tire-set',
            quantity: 1,
            createdAt: '2025-01-10T08:00:00Z',
            updatedAt: '2025-01-10T08:00:00Z',
          },
        ],
      },
    ],
  },
  {
    packageID: 'package-2',
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_1,
    name: 'Full Service Package',
    description: 'Complete vehicle service and inspection',
    packageStatus: 'Active',
    from: '2025-01-01',
    to: '2025-12-31',
    createdAt: '2025-01-12T08:00:00Z',
    updatedAt: '2025-01-12T08:00:00Z',
    packageVariants: [
      {
        packageVariantID: 'package-variant-3',
        packageID: 'package-2',
        name: 'Standard Service',
        price: '3200',
        currency: 'SEK',
        estimatedDurationMinutes: 120,
        packageVariantStatus: 'Active',
        sortOrder: 1,
        createdAt: '2025-01-12T08:00:00Z',
        updatedAt: '2025-01-12T08:00:00Z',
        packageServices: [
          {
            packageServiceID: 'package-service-4',
            packageVariantID: 'package-variant-3',
            serviceID: 'service-full-inspection',
            quantity: 1,
            createdAt: '2025-01-12T08:00:00Z',
            updatedAt: '2025-01-12T08:00:00Z',
          },
          {
            packageServiceID: 'package-service-5',
            packageVariantID: 'package-variant-3',
            serviceID: 'service-oil-change',
            quantity: 1,
            createdAt: '2025-01-12T08:00:00Z',
            updatedAt: '2025-01-12T08:00:00Z',
          },
        ],
        packageProducts: [
          {
            packageProductID: 'package-product-3',
            packageVariantID: 'package-variant-3',
            productID: 'product-engine-oil',
            quantity: 1,
            createdAt: '2025-01-12T08:00:00Z',
            updatedAt: '2025-01-12T08:00:00Z',
          },
        ],
      },
    ],
  },
  {
    packageID: 'package-3',
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_2,
    name: 'Brake Care Package',
    description: 'Brake inspection and pad replacement',
    packageStatus: 'Active',
    from: '2025-01-01',
    to: '2025-12-31',
    createdAt: '2025-01-15T08:00:00Z',
    updatedAt: '2025-01-15T08:00:00Z',
    packageVariants: [
      {
        packageVariantID: 'package-variant-4',
        packageID: 'package-3',
        name: 'Standard',
        price: '2350',
        currency: 'SEK',
        estimatedDurationMinutes: 90,
        packageVariantStatus: 'Active',
        sortOrder: 1,
        createdAt: '2025-01-15T08:00:00Z',
        updatedAt: '2025-01-15T08:00:00Z',
        packageServices: [
          {
            packageServiceID: 'package-service-6',
            packageVariantID: 'package-variant-4',
            serviceID: 'service-brake-replacement',
            quantity: 1,
            createdAt: '2025-01-15T08:00:00Z',
            updatedAt: '2025-01-15T08:00:00Z',
          },
        ],
        packageProducts: [
          {
            packageProductID: 'package-product-4',
            packageVariantID: 'package-variant-4',
            productID: 'product-brake-pads',
            quantity: 1,
            createdAt: '2025-01-15T08:00:00Z',
            updatedAt: '2025-01-15T08:00:00Z',
          },
        ],
      },
    ],
  },
  {
    packageID: 'package-4',
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_2,
    name: 'Wheel Alignment Package',
    description: 'Four-wheel alignment and balancing',
    packageStatus: 'Inactive',
    from: '2025-01-01',
    to: '2025-12-31',
    createdAt: '2025-01-18T08:00:00Z',
    updatedAt: '2025-01-18T08:00:00Z',
    packageVariants: [
      {
        packageVariantID: 'package-variant-5',
        packageID: 'package-4',
        name: 'Standard',
        price: '1100',
        currency: 'SEK',
        estimatedDurationMinutes: 40,
        packageVariantStatus: 'Inactive',
        sortOrder: 1,
        createdAt: '2025-01-18T08:00:00Z',
        updatedAt: '2025-01-18T08:00:00Z',
        packageServices: [
          {
            packageServiceID: 'package-service-7',
            packageVariantID: 'package-variant-5',
            serviceID: 'service-wheel-alignment',
            quantity: 1,
            createdAt: '2025-01-18T08:00:00Z',
            updatedAt: '2025-01-18T08:00:00Z',
          },
        ],
        packageProducts: [],
      },
    ],
  },
]
